import { useEffect, useState } from "react";
import axios from "axios";
import { DEFAULT_PRACTICE_TIMEZONE } from "../practiceTimezone";
import { useContextStateManagement } from "../context/ContextApi";

// For pages whose own list-fetching endpoint returns a bare array/legacy body shape that can't
// carry the resolved timezone alongside it (no X-Practice-Timezone header, no practiceTimezone
// field) - fetches it once from the small standalone /api/getEffectivePracticeTimezone endpoint
// instead. Falls back to DEFAULT_PRACTICE_TIMEZONE (same as every other timezone-aware page)
// while loading or on error, so date rendering never breaks even before this resolves.
export function usePracticeTimezone(practiceId, token) {
  const [practiceTimezone, setPracticeTimezone] = useState(DEFAULT_PRACTICE_TIMEZONE);
  // Refetches when the user saves a new timezone in Settings, instead of only resolving once
  // at mount and requiring a page reload to pick up the change.
  const { timezonePreferenceVersion } = useContextStateManagement();

  useEffect(() => {
    if (!practiceId || !token) return undefined;
    let cancelled = false;

    (async () => {
      try {
        const response = await axios.get("/api/getEffectivePracticeTimezone", {
          headers: { Authorization: `Bearer ${token}` },
          params: { PracticeId: practiceId },
        });
        if (!cancelled && response.data?.timeZone) {
          setPracticeTimezone(response.data.timeZone);
        }
      } catch (error) {
        // Keep the default - a failed lookup shouldn't block the rest of the page from rendering.
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [practiceId, token, timezonePreferenceVersion]);

  return practiceTimezone;
}
